import React from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";

import {
  AdminsPage,
  DashboardPage,
  HelpPage,
  InvoicePage,
  InvoicesPage,
  NotFoundPage,
  OrganizationProfilePage,
  OrganizationsPage,
  ProfilePage,
  SessionCallPage,
  SessionCompletionPage,
  SessionCallPreviewPage,
  SessionsPage,
  TrainingPage,
  UsersPage
} from "pages";
import { isLogin } from "utils/auth";
import { useUser } from "context/user";
import { logout } from "utils/auth";

export const ProtectedRoutes: React.FC = () => {
  const history = useHistory();
  const { user } = useUser()!;
  const toPath = history.location.pathname;
  if (!isLogin() && toPath !== "/login") {
    history.push(`/login?to=${history.location.pathname}`);
    return <></>;
  }
  if (user.id && user.privs < 1) logout();

  return (
    <>
      <Switch>
        <Route path="/dashboard" component={DashboardPage} />
        <Route path="/training" component={TrainingPage} />
        <Route path="/clients" component={UsersPage} />
        <Route path="/coaches" component={AdminsPage} />
        <Route path="/help" component={HelpPage} />
        <Route path="/profile" component={ProfilePage} />
        <Route path="/invoice/:invoiceId" component={InvoicePage} />
        <Route path="/organizations" component={OrganizationsPage} />
        <Route
          path="/organization/:organizationId/invoices"
          component={InvoicesPage}
        />
        <Route
          path="/organization/:organizationId"
          component={OrganizationProfilePage}
        />
        <Route path="/sessions" component={SessionsPage} />
        <Route path="/session/:sessionId/join" component={SessionCallPage} />
        <Route path="/session/:sessionId/completionpage" component={SessionCompletionPage} />
        <Route
          path="/session/:sessionId/preview"
          component={SessionCallPreviewPage}
        />
        <Redirect exact from="/" to="/dashboard" />
        <Route component={() => <NotFoundPage />} />
      </Switch>
    </>
  );
};

export default ProtectedRoutes;
